import React from "react";
import BottomSheet from "../../../components/ui/BottomSheet";
import SheetHeader from "../../../components/ui/SheetHeader";
import Button from "../../../components/ui/Button";
import Icon from "../../../components/ui/Icon";
import { useIsDesktopViewport } from "../../../hooks/useIsDesktopViewport";
import {
  Body,
  IconBadge,
  Message,
  FieldLabel,
  LabelText,
  Textarea,
  Actions,
} from "./CancelSaleModal.styles";

interface CancelSaleModalProps {
  isOpen: boolean;
  onClose: () => void;
  motivo: string;
  setMotivo: (value: string) => void;
  onConfirm: () => void;
}

// `motivo` is part of the props signature (mirroring MoneyPaymentModal's
// formValues/setFormValues-style controlled-field prop) but intentionally NOT
// destructured/read below: the textarea has no `value` prop (it is uncontrolled --
// only `onChange` feeds `setMotivo`). Reading `motivo` here to bind it to `value`
// would be a real, unauthorized behavior change, so this preserves that
// pre-existing quirk exactly (carried over from the pre-Fase-5 ShowModal version).
export default function CancelSaleModal({
  isOpen,
  onClose,
  setMotivo,
  onConfirm,
}: CancelSaleModalProps) {
  const desktop = useIsDesktopViewport();

  return (
    <BottomSheet open={isOpen} onClose={onClose} centered={desktop} maxHeight="60%">
      <SheetHeader title="Cancelar pedido" onClose={onClose} />
      <Body>
        <IconBadge>
          <Icon name="x" size={24} strokeWidth={2.4} />
        </IconBadge>
        <Message>Deseja realmente cancelar a venda? Informe o motivo abaixo.</Message>
        <FieldLabel>
          <LabelText>Motivo do cancelamento</LabelText>
          <Textarea
            aria-label="Motivo do cancelamento"
            placeholder="Ex.: Informei o endereço incorreto"
            onChange={(ev) => {
              setMotivo(ev.target.value);
            }}
          />
        </FieldLabel>
        <Actions>
          <Button variant="ghost" full onClick={onClose}>
            Voltar
          </Button>
          <Button variant="primary" full onClick={onConfirm}>
            Confirmar cancelamento
          </Button>
        </Actions>
      </Body>
    </BottomSheet>
  );
}
